var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"lbl--reset input--radio"},[_c('input',{attrs:{"type":"radio","name":_vm.name,"disabled":_vm.isDisabled},domProps:{"checked":this.value.toString() === this.data.toString()},on:{"change":_vm.change}}),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }